var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 19",
    fill: "#57454A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5569 2.53423C9.68634 1.69887 8.31183 1.69887 7.44126 2.53423L2.81482 6.97357C2.70147 7.08234 2.62522 7.22402 2.59689 7.37854C2.04276 10.4004 2.00185 13.494 2.4759 16.5295L2.58842 17.25H5.56488V11.0387C5.56488 10.6244 5.90066 10.2887 6.31488 10.2887H11.6833C12.0975 10.2887 12.4333 10.6244 12.4333 11.0387V17.25H15.4098L15.5223 16.5295C15.9963 13.494 15.9554 10.4004 15.4013 7.37854C15.3729 7.22402 15.2967 7.08234 15.1833 6.97357L10.5569 2.53423ZM6.40271 1.45191C7.85366 0.0596485 10.1445 0.0596485 11.5955 1.45191L16.2219 5.89125C16.5625 6.21804 16.7915 6.64373 16.8767 7.10799C17.4612 10.2956 17.5044 13.559 17.0043 16.7609L16.8235 17.9184C16.7488 18.3971 16.3365 18.75 15.852 18.75H11.6833C11.2691 18.75 10.9333 18.4142 10.9333 18V11.7887H7.06488V18C7.06488 18.4142 6.72909 18.75 6.31488 18.75H2.14615C1.66166 18.75 1.24938 18.3971 1.17462 17.9184L0.993861 16.7609C0.493812 13.559 0.53696 10.2956 1.12149 7.10799C1.20662 6.64373 1.43571 6.21804 1.77628 5.89125L6.40271 1.45191Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.f72698a18a9b9a1d43c8ed404c6a7028.svg";
export { ForwardRef as ReactComponent };